import { AssetSortType } from "@nf/common";

export const buildSortField = (
  sort: string | string[] | undefined,
  language: string
) => {
  return sort === AssetSortType.Alphabetical
    ? `localized.${language}.sortingTitle`
    : `${sort || AssetSortType.Popular}`;
};
